// Asia/Riyadh calendar-day presets. The backend expands YYYY-MM-DD to Riyadh
// day boundaries, so no timezone maths is duplicated on the client.

export const DATE_PRESETS = [
  { key: 'today', label: 'Today' },
  { key: 'week', label: 'This Week' },
  { key: 'month', label: 'This Month' },
  { key: 'last30', label: 'Last 30 Days' },
  { key: 'year', label: 'This Year' },
  { key: 'all', label: 'All Time' },
];

function riyadhTodayParts() {
  const fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Riyadh', year: 'numeric', month: '2-digit', day: '2-digit',
  });
  const [y, m, d] = fmt.format(new Date()).split('-').map(Number);
  return { y, m, d };
}

function iso(y, m, d) {
  return new Date(Date.UTC(y, m - 1, d)).toISOString().slice(0, 10);
}

export function getPresetDates(key) {
  const { y, m, d } = riyadhTodayParts();
  const today = iso(y, m, d);
  const dow = new Date(Date.UTC(y, m - 1, d)).getUTCDay();
  switch (key) {
    case 'today': return { from: today, to: today };
    case 'week': return { from: iso(y, m, d - dow), to: today };
    case 'month': return { from: iso(y, m, 1), to: today };
    case 'last30': return { from: iso(y, m, d - 29), to: today };
    case 'year': return { from: iso(y, 1, 1), to: today };
    default: return { from: '', to: '' };
  }
}

export function downloadCsvFile(content, filename) {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
